import { useCallback, useState, useRef } from 'react';
import PropTypes from 'prop-types';

import FileMenuHandler from './FileMenuHandler.jsx';

const FileMenu = (props) => {
  const { getComponent, backendSpecsActions, backendSpecsSelectors, viewerMode } = props;
  const fileMenuHandler = useRef(null);
  const [isLoadFromBackendOpen, setIsLoadFromBackendOpen] = useState(false);

  const DropdownMenu = getComponent('DropdownMenu');
  const DropdownMenuItemDivider = getComponent('DropdownMenuItemDivider');
  const ImportUrlMenuItem = getComponent('TopBarFileMenuImportUrlMenuItem', true);
  const ImportFileMenuItem = getComponent('TopBarFileMenuImportFileMenuItem', true);
  const LoadExampleNestedMenu = getComponent('TopBarFileMenuLoadExampleNestedMenu', true);
  const LoadFromBackendMenuItem = getComponent('LoadFromBackendMenuItem', true);
  const LoadFromBackendDialog = getComponent('LoadFromBackendDialog', true);
  const NewSpecMenuItem = getComponent('NewSpecMenuItem', true);
  const SaveAsMenuItem = getComponent('TopBarFileMenuSaveAsMenuItem', true);
  const ConvertAndSaveAsJSONMenuItem = getComponent(
    'TopBarFileMenuConvertAndSaveAsJSONMenuItem',
    true
  );
  const ConvertAndSaveAsYAMLMenuItem = getComponent(
    'TopBarFileMenuConvertAndSaveAsYAMLMenuItem',
    true
  );
  const DownloadResolvedJSONMenuItem = getComponent(
    'TopBarFileMenuDownloadResolvedJSONMenuItem',
    true
  );
  const DownloadResolvedYAMLMenuItem = getComponent(
    'TopBarFileMenuDownloadResolvedYAMLMenuItem',
    true
  );

  const handleUrlImportClick = useCallback((event) => {
    fileMenuHandler.current.importURL(event);
  }, []);
  const handleFileImportClick = useCallback(async (event) => {
    await fileMenuHandler.current.importFile(event);
  }, []);
  const handleSaveAsClick = useCallback(async (event) => {
    await fileMenuHandler.current.saveAs(event);
  }, []);
  const handleConvertAndSaveAsJSONClick = useCallback(async (event) => {
    await fileMenuHandler.current.convertAndSaveAsJSON(event);
  }, []);
  const handleConvertAndSaveAsYAMLClick = useCallback(async (event) => {
    await fileMenuHandler.current.convertAndSaveAsYAML(event);
  }, []);
  const handleDownloadResolvedJSONClick = useCallback(async (event) => {
    await fileMenuHandler.current.downloadResolvedJSON(event);
  }, []);
  const handleDownloadResolvedYAMLClick = useCallback(async (event) => {
    await fileMenuHandler.current.downloadResolvedYAML(event);
  }, []);

  const handleLoadFromBackendClick = useCallback((event) => {
    event.preventDefault();
    setIsLoadFromBackendOpen(true);
  }, []);

  const handleLoadFromBackendClose = useCallback(() => {
    setIsLoadFromBackendOpen(false);
  }, []);

  const handleLoadFromBackendSelect = useCallback(
    async (specId) => {
      if (backendSpecsActions?.loadSpecIntoEditor) {
        await backendSpecsActions.loadSpecIntoEditor(specId);
      }
      setIsLoadFromBackendOpen(false);
    },
    [backendSpecsActions]
  );

  // New spec handler
  const handleNewClick = useCallback(
    (event) => {
      event.preventDefault();
      if (backendSpecsActions?.newSpec) {
        backendSpecsActions.newSpec();
      }
    },
    [backendSpecsActions]
  );

  return (
    <>
      {/* eslint-disable-next-line react/jsx-props-no-spreading */}
      {!viewerMode && <FileMenuHandler {...props} ref={fileMenuHandler} />}
      {LoadFromBackendDialog && (
        <LoadFromBackendDialog
          isOpen={isLoadFromBackendOpen}
          onClose={handleLoadFromBackendClose}
          onSelect={handleLoadFromBackendSelect}
          getComponent={getComponent}
          backendSpecsActions={backendSpecsActions}
          backendSpecsSelectors={backendSpecsSelectors}
        />
      )}
      <DropdownMenu label="File">
        {viewerMode ? (
          <>
            {LoadFromBackendMenuItem && (
              <LoadFromBackendMenuItem onClick={handleLoadFromBackendClick} />
            )}
          </>
        ) : (
          <>
            {NewSpecMenuItem && <NewSpecMenuItem onClick={handleNewClick} />}
            <DropdownMenuItemDivider />
            <ImportUrlMenuItem onClick={handleUrlImportClick} />
            <ImportFileMenuItem onClick={handleFileImportClick} />
            {LoadFromBackendMenuItem && (
              <LoadFromBackendMenuItem onClick={handleLoadFromBackendClick} />
            )}
            <LoadExampleNestedMenu />
            <DropdownMenuItemDivider />
            <SaveAsMenuItem onClick={handleSaveAsClick} />
            <ConvertAndSaveAsJSONMenuItem onClick={handleConvertAndSaveAsJSONClick} />
            <ConvertAndSaveAsYAMLMenuItem onClick={handleConvertAndSaveAsYAMLClick} />
            <DropdownMenuItemDivider />
            <DownloadResolvedJSONMenuItem onClick={handleDownloadResolvedJSONClick} />
            <DownloadResolvedYAMLMenuItem onClick={handleDownloadResolvedYAMLClick} />
          </>
        )}
      </DropdownMenu>
    </>
  );
};

FileMenu.propTypes = {
  getComponent: PropTypes.func.isRequired,
};

export default FileMenu;
